<template>
  <div class="globe-wrapper">
    <MapGetter
      v-slot="{ map }"
      container="timeline-members-map"
      type="mapbox"
      theme="mono"
      :globe="true"
      :showBorder="false"
      :pitch="30"
      :center="[140, 30]"
      :zoom="0"
      :showControl="false"
    >
      <Map
        :map="map"
        :globeActive="globeActive"
        :year="year"
        :visibleMembers="visibleMembers"
      />
    </MapGetter>
    <div class="footer-wrap" :class="{ 'show-footer': show }">
      <div class="footer-img" :class="{ 'show-img': show }">
        <img
          src="https://ieamaps.blob.core.windows.net/test/50-anniversary/img/timeline/IEA-50-logo.png"
          alt="IEA-50th-anniversary-logo"
        />
      </div>
      <!-- <div class="footer-label" :class="{ 'show-label': show }">
        IEA celebrates<br />50th anniversary
      </div> -->
    </div>
  </div>
</template>

<script>
import { MapGetter } from "@international-energy-agency/vue-ui/maps";
import Map from "./Map.vue";
export default {
  components: {
    Map,
    MapGetter,
  },
  computed: {
    show() {
      return this.year === 2024 ? true : false;
    },
  },
  props: {
    year: {
      required: true,
    },
    globeActive: {
      type: Boolean,
      required: true,
    },
    visibleMembers: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>
.globe-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  background: #e3e3e3;
}
.footer-wrap {
  z-index: 10;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -60%);
  display: flex;
  visibility: hidden;
  flex-flow: column;
  align-items: center;
  transition: all 0.49s ease-out;
}
.footer-label {
  font-size: 2rem;
  line-height: 2.25rem;
  font-weight: 600;
  text-align: center;
  opacity: 0;
}
.footer-wrap .footer-img {
  width: 300px;
  margin-bottom: 14px;
  opacity: 0;
  transform: translateY(50%);
}
.footer-img img {
  width: 100%;
}
.show-footer {
  visibility: visible;
}
.show-img {
  opacity: 1 !important;
  transform: translateY(0) !important;
  transition: all 0.29s ease-out;
  transition-delay: 0.29s;
}
.show-label {
  opacity: 1;
  transition: all 0.29s ease-out;
}
@media screen and (max-width: 529px) {
  .footer-wrap .footer-img {
    width: 200px;
    
  }
}
</style>
